// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Notes {
    width: 100%;
    height: 100%;
    padding: 46px 56px 30px 30px;
    display: flex;
    flex-direction: column;
    background: #f9f9f6;
}

.Notes_close {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 6px;
    font-size: 20px;
    color: #86868B;
    transition: all 0.2s;
}

.Notes_close:hover {
    background: #F5F5F7;
    color: #1D1D1F;
}

.Notes_content {
    flex: 1;
    display: flex;
    gap: 20px;
    overflow: hidden;
}

.Notes_loading,
.Notes_error {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
}

.Notes_error {
    color: #d32f2f;
}

/* Notes List */
.Notes_list {
    width: 300px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.Notes_list_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 8px;
}

.Notes_list_title {
    font-weight: 500;
    font-size: 20px;
    line-height: 27px;
    color: #1D1D1F;
}

.Notes_list_add_button {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s;
    opacity: 0.7;
}

.Notes_list_add_button:hover {
    opacity: 1;
}

.Notes_list_add_plus {
    width: 16px;
    height: 16px;
    position: relative;
}

.Notes_list_add_plus::before,
.Notes_list_add_plus::after {
    content: '';
    position: absolute;
    background: #1D1D1F;
}

.Notes_list_add_plus::before {
    width: 100%;
    height: 2px;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
}

.Notes_list_add_plus::after {
    width: 2px;
    height: 100%;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
}

.Notes_list_items {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow-y: auto;
}

.Notes_item {
    padding: 12px;
    background: #f9f9f6;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
    border: 0.5px solid #E5E5EA;
}

.Notes_item:hover {
    background: #FAFAFA;
}

.Notes_item_selected {
    background: #F5F5F7;
}

.Notes_item_title {
    font-weight: 500;
    font-size: 13px;
    color: #1D1D1F;
    margin-bottom: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.Notes_item_date {
    font-size: 11px;
    color: #86868B;
}

.Notes_empty {
    padding: 20px;
    text-align: center;
    color: #86868B;
    font-style: italic;
    font-size: 13px;
}

/* Editor Area */
.Notes_editor {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    height: 100%;
}

.Notes_editor_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;
}

.Notes_editor_title {
    flex: 1;
    min-width: 0;
}

.Notes_editor_title h2 {
    margin: 0;
    font-size: 22px;
    font-weight: 500;
    color: #1D1D1F;
    cursor: pointer;
    padding: 0px 8px;
    border-radius: 6px;
    transition: background 0.2s;
}

.Notes_editor_title h2:hover {
    background: #F5F5F7;
}

.Notes_editor_title_input {
    width: 100%;
    font-size: 22px;
    font-weight: 500;
    color: #1D1D1F;
    padding: 0px 8px;
    border: 0.5px solid #007AFF;
    border-radius: 6px;
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
}

.Notes_editor_bound_toggle {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 13px;
    color: #86868B;
    transition: color 0.2s;
    user-select: none;
}

.Notes_editor_bound_toggle:hover {
    color: #1D1D1F;
}

.Notes_editor_bound_toggle input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: #007AFF;
}

.Notes_editor_delete {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 8px;
    border-radius: 6px;
    transition: background 0.2s;
    flex-shrink: 0;
}

.Notes_editor_delete:hover {
    background: #F5F5F7;
}

.Notes_editor_delete .Notes_toolbar_icon {
    opacity: 0.6;
}

.Notes_editor_delete:hover .Notes_toolbar_icon {
    opacity: 1;
}

.Notes_toolbar {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px;
    background: #f9f9f6;
    border-radius: 6px;
    border: 0.5px solid #E5E5EA;
    margin-bottom: 16px;
    flex-wrap: wrap;
}

.Notes_toolbar button,
.Notes_toolbar select {
    padding: 6px 12px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 13px;
    font-weight: 500;
    color: #86868B;
}

.Notes_toolbar button:hover,
.Notes_toolbar select:hover {
    background: #F5F5F7;
    color: #1D1D1F;
}

.Notes_toolbar button:active {
    transform: scale(0.98);
}

.Notes_toolbar_separator {
    width: 0.5px;
    height: 24px;
    background: #D1D1D6;
}

.Notes_toolbar_color {
    width: 40px;
    height: 32px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    background: transparent;
}

.Notes_toolbar_save {
    background: transparent;
    color: #1D1D1F;
    font-size: 13px;
    border: none;
    padding: 7px 16px;
    font-weight: 500;
}

.Notes_toolbar_save:hover {
    background: #F5F5F7;
}

.Notes_toolbar_save:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.Notes_toolbar_save_saving {
    animation: pulse 1s ease-in-out infinite;
}

@keyframes pulse {
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.02);
    }
}

.Notes_toolbar_delete {
    background: transparent;
    color: #1D1D1F;
    border: none;
    margin-left: auto;
    font-weight: 500;
}

.Notes_toolbar_delete:hover {
    background: #F5F5F7;
    color: #FF3B30;
}

.Notes_toolbar_icon {
    width: 16px;
    height: 16px;
    display: block;
    opacity: 0.7;
}

.Notes_toolbar_save:hover .Notes_toolbar_icon,
.Notes_toolbar_delete:hover .Notes_toolbar_icon {
    opacity: 1;
}

/* Alignment button icons */
.Notes_align_icon {
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 16px;
    height: 14px;
}

.Notes_align_icon span {
    height: 2px;
    background: currentColor;
    border-radius: 1px;
}

.Notes_align_left span:nth-child(1) { width: 100%; }
.Notes_align_left span:nth-child(2) { width: 80%; }
.Notes_align_left span:nth-child(3) { width: 90%; }

.Notes_align_center span:nth-child(1) { width: 100%; margin: 0 auto; }
.Notes_align_center span:nth-child(2) { width: 80%; margin: 0 auto; }
.Notes_align_center span:nth-child(3) { width: 90%; margin: 0 auto; }

.Notes_align_right span:nth-child(1) { width: 100%; margin-left: auto; }
.Notes_align_right span:nth-child(2) { width: 80%; margin-left: auto; }
.Notes_align_right span:nth-child(3) { width: 90%; margin-left: auto; }

.Notes_editor_content {
    flex: 1;
    padding: 16px;
    border: 0.5px solid #D1D1D6;
    border-radius: 6px;
    overflow-y: auto;
    font-size: 15px;
    line-height: 1.6;
    color: #1D1D1F;
    outline: none;
    background: #f9f9f6;
}

/* Font size styling for execCommand font sizes */
.Notes_editor_content font[size="1"] {
    font-size: 10px;
}

.Notes_editor_content font[size="2"] {
    font-size: 13px;
}

.Notes_editor_content font[size="3"] {
    font-size: 16px;
}

.Notes_editor_content font[size="4"] {
    font-size: 20px;
}

.Notes_editor_content font[size="5"] {
    font-size: 24px;
}

.Notes_editor_content font[size="6"] {
    font-size: 32px;
}

.Notes_editor_content font[size="7"] {
    font-size: 48px;
}

.Notes_editor_content:focus {
    border-color: #007AFF;
    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);
}

.Notes_empty_editor {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #86868B;
    font-size: 15px;
    font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/notes/Notes.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;;IAEI,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,YAAY;IACZ,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,QAAQ;IACR,OAAO;IACP,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,MAAM;IACN,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;AAEA;;IAEI,UAAU;AACd;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA,sCAAsC,WAAW,EAAE;AACnD,sCAAsC,UAAU,EAAE;AAClD,sCAAsC,UAAU,EAAE;;AAElD,wCAAwC,WAAW,EAAE,cAAc,EAAE;AACrE,wCAAwC,UAAU,EAAE,cAAc,EAAE;AACpE,wCAAwC,UAAU,EAAE,cAAc,EAAE;;AAEpE,uCAAuC,WAAW,EAAE,iBAAiB,EAAE;AACvE,uCAAuC,UAAU,EAAE,iBAAiB,EAAE;AACtE,uCAAuC,UAAU,EAAE,iBAAiB,EAAE;;AAEtE;IACI,OAAO;IACP,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA,iDAAiD;AACjD;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB","sourcesContent":[".Notes {\n    width: 100%;\n    height: 100%;\n    padding: 46px 56px 30px 30px;\n    display: flex;\n    flex-direction: column;\n    background: #f9f9f6;\n}\n\n.Notes_close {\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border-radius: 6px;\n    font-size: 20px;\n    color: #86868B;\n    transition: all 0.2s;\n}\n\n.Notes_close:hover {\n    background: #F5F5F7;\n    color: #1D1D1F;\n}\n\n.Notes_content {\n    flex: 1;\n    display: flex;\n    gap: 20px;\n    overflow: hidden;\n}\n\n.Notes_loading,\n.Notes_error {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n}\n\n.Notes_error {\n    color: #d32f2f;\n}\n\n/* Notes List */\n.Notes_list {\n    width: 300px;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.Notes_list_header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-bottom: 8px;\n}\n\n.Notes_list_title {\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 27px;\n    color: #1D1D1F;\n}\n\n.Notes_list_add_button {\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: opacity 0.2s;\n    opacity: 0.7;\n}\n\n.Notes_list_add_button:hover {\n    opacity: 1;\n}\n\n.Notes_list_add_plus {\n    width: 16px;\n    height: 16px;\n    position: relative;\n}\n\n.Notes_list_add_plus::before,\n.Notes_list_add_plus::after {\n    content: '';\n    position: absolute;\n    background: #1D1D1F;\n}\n\n.Notes_list_add_plus::before {\n    width: 100%;\n    height: 2px;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n}\n\n.Notes_list_add_plus::after {\n    width: 2px;\n    height: 100%;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.Notes_list_items {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    overflow-y: auto;\n}\n\n.Notes_item {\n    padding: 12px;\n    background: #f9f9f6;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s;\n    border: 0.5px solid #E5E5EA;\n}\n\n.Notes_item:hover {\n    background: #FAFAFA;\n}\n\n.Notes_item_selected {\n    background: #F5F5F7;\n}\n\n.Notes_item_title {\n    font-weight: 500;\n    font-size: 13px;\n    color: #1D1D1F;\n    margin-bottom: 4px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.Notes_item_date {\n    font-size: 11px;\n    color: #86868B;\n}\n\n.Notes_empty {\n    padding: 20px;\n    text-align: center;\n    color: #86868B;\n    font-style: italic;\n    font-size: 13px;\n}\n\n/* Editor Area */\n.Notes_editor {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    height: 100%;\n}\n\n.Notes_editor_header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 16px;\n}\n\n.Notes_editor_title {\n    flex: 1;\n    min-width: 0;\n}\n\n.Notes_editor_title h2 {\n    margin: 0;\n    font-size: 22px;\n    font-weight: 500;\n    color: #1D1D1F;\n    cursor: pointer;\n    padding: 0px 8px;\n    border-radius: 6px;\n    transition: background 0.2s;\n}\n\n.Notes_editor_title h2:hover {\n    background: #F5F5F7;\n}\n\n.Notes_editor_title_input {\n    width: 100%;\n    font-size: 22px;\n    font-weight: 500;\n    color: #1D1D1F;\n    padding: 0px 8px;\n    border: 0.5px solid #007AFF;\n    border-radius: 6px;\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);\n}\n\n.Notes_editor_bound_toggle {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-size: 13px;\n    color: #86868B;\n    transition: color 0.2s;\n    user-select: none;\n}\n\n.Notes_editor_bound_toggle:hover {\n    color: #1D1D1F;\n}\n\n.Notes_editor_bound_toggle input[type=\"checkbox\"] {\n    width: 16px;\n    height: 16px;\n    cursor: pointer;\n    accent-color: #007AFF;\n}\n\n.Notes_editor_delete {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 8px;\n    border-radius: 6px;\n    transition: background 0.2s;\n    flex-shrink: 0;\n}\n\n.Notes_editor_delete:hover {\n    background: #F5F5F7;\n}\n\n.Notes_editor_delete .Notes_toolbar_icon {\n    opacity: 0.6;\n}\n\n.Notes_editor_delete:hover .Notes_toolbar_icon {\n    opacity: 1;\n}\n\n.Notes_toolbar {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 10px;\n    background: #f9f9f6;\n    border-radius: 6px;\n    border: 0.5px solid #E5E5EA;\n    margin-bottom: 16px;\n    flex-wrap: wrap;\n}\n\n.Notes_toolbar button,\n.Notes_toolbar select {\n    padding: 6px 12px;\n    border: none;\n    background: transparent;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.2s;\n    font-size: 13px;\n    font-weight: 500;\n    color: #86868B;\n}\n\n.Notes_toolbar button:hover,\n.Notes_toolbar select:hover {\n    background: #F5F5F7;\n    color: #1D1D1F;\n}\n\n.Notes_toolbar button:active {\n    transform: scale(0.98);\n}\n\n.Notes_toolbar_separator {\n    width: 0.5px;\n    height: 24px;\n    background: #D1D1D6;\n}\n\n.Notes_toolbar_color {\n    width: 40px;\n    height: 32px;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    background: transparent;\n}\n\n.Notes_toolbar_save {\n    background: transparent;\n    color: #1D1D1F;\n    font-size: 13px;\n    border: none;\n    padding: 7px 16px;\n    font-weight: 500;\n}\n\n.Notes_toolbar_save:hover {\n    background: #F5F5F7;\n}\n\n.Notes_toolbar_save:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.Notes_toolbar_save_saving {\n    animation: pulse 1s ease-in-out infinite;\n}\n\n@keyframes pulse {\n    0%, 100% {\n        transform: scale(1);\n    }\n    50% {\n        transform: scale(1.02);\n    }\n}\n\n.Notes_toolbar_delete {\n    background: transparent;\n    color: #1D1D1F;\n    border: none;\n    margin-left: auto;\n    font-weight: 500;\n}\n\n.Notes_toolbar_delete:hover {\n    background: #F5F5F7;\n    color: #FF3B30;\n}\n\n.Notes_toolbar_icon {\n    width: 16px;\n    height: 16px;\n    display: block;\n    opacity: 0.7;\n}\n\n.Notes_toolbar_save:hover .Notes_toolbar_icon,\n.Notes_toolbar_delete:hover .Notes_toolbar_icon {\n    opacity: 1;\n}\n\n/* Alignment button icons */\n.Notes_align_icon {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    width: 16px;\n    height: 14px;\n}\n\n.Notes_align_icon span {\n    height: 2px;\n    background: currentColor;\n    border-radius: 1px;\n}\n\n.Notes_align_left span:nth-child(1) { width: 100%; }\n.Notes_align_left span:nth-child(2) { width: 80%; }\n.Notes_align_left span:nth-child(3) { width: 90%; }\n\n.Notes_align_center span:nth-child(1) { width: 100%; margin: 0 auto; }\n.Notes_align_center span:nth-child(2) { width: 80%; margin: 0 auto; }\n.Notes_align_center span:nth-child(3) { width: 90%; margin: 0 auto; }\n\n.Notes_align_right span:nth-child(1) { width: 100%; margin-left: auto; }\n.Notes_align_right span:nth-child(2) { width: 80%; margin-left: auto; }\n.Notes_align_right span:nth-child(3) { width: 90%; margin-left: auto; }\n\n.Notes_editor_content {\n    flex: 1;\n    padding: 16px;\n    border: 0.5px solid #D1D1D6;\n    border-radius: 6px;\n    overflow-y: auto;\n    font-size: 15px;\n    line-height: 1.6;\n    color: #1D1D1F;\n    outline: none;\n    background: #f9f9f6;\n}\n\n/* Font size styling for execCommand font sizes */\n.Notes_editor_content font[size=\"1\"] {\n    font-size: 10px;\n}\n\n.Notes_editor_content font[size=\"2\"] {\n    font-size: 13px;\n}\n\n.Notes_editor_content font[size=\"3\"] {\n    font-size: 16px;\n}\n\n.Notes_editor_content font[size=\"4\"] {\n    font-size: 20px;\n}\n\n.Notes_editor_content font[size=\"5\"] {\n    font-size: 24px;\n}\n\n.Notes_editor_content font[size=\"6\"] {\n    font-size: 32px;\n}\n\n.Notes_editor_content font[size=\"7\"] {\n    font-size: 48px;\n}\n\n.Notes_editor_content:focus {\n    border-color: #007AFF;\n    box-shadow: 0 0 0 3px rgba(0, 122, 255, 0.1);\n}\n\n.Notes_empty_editor {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #86868B;\n    font-size: 15px;\n    font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
